export default "__VITE_ASSET__mS4Bka$s__"